export interface BaseDropDownItem {
  key: string;
  value: string | number;
}
